import React from "react";
import { Rocket } from "lucide-react";
import { chairman } from "../mock";

const Welcome = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div>
          <p className="text-[#1f9d4c] font-bold tracking-widest text-sm uppercase mb-3">
            Welcome Message
          </p>

          <h2
            className="text-3xl md:text-4xl font-black text-slate-900 leading-tight mb-2"
            style={{ fontFamily: "'Alegreya Sans', sans-serif" }}
          >
            {chairman.name}
          </h2>

          <p className="text-slate-500 font-semibold mb-6 border-l-4 border-[#1f9d4c] pl-3">
            {chairman.title}
          </p>

          <div className="space-y-4 text-slate-600 leading-relaxed text-[17px]">
            {chairman.message.map((p) => (
              <p key={p.slice(0, 32)}>{p}</p>
            ))}
          </div>

          <button className="mt-7 inline-flex items-center gap-2 px-6 py-3 bg-[#0a2463] hover:bg-[#ff6b00] text-white font-bold rounded-sm shadow-md transition-colors duration-300">
            <Rocket size={18} />
            Read more...
          </button>
        </div>

        <div className="relative">
          <div className="absolute -bottom-6 -right-6 w-40 h-40 grid grid-cols-8 gap-1.5 opacity-60 z-0">
            {Array.from({ length: 64 }).map((_, i) => (
              <span key={`dot-${i}`} className="w-1 h-1 rounded-full bg-slate-400" />
            ))}
          </div>

          <div className="absolute -bottom-6 -right-6 w-full h-full bg-slate-100 z-0" />

          <div className="relative z-10 overflow-hidden bg-gradient-to-br from-slate-50 to-slate-100">
            <img
              src={chairman.image}
              alt={chairman.name}
              className="w-full h-[560px] object-cover object-top"
            />

            <div className="absolute top-8 right-0 bg-[#0a2463] text-white px-6 py-5 max-w-[220px] shadow-xl">
              <h3
                className="font-bold text-lg leading-tight"
                style={{ fontFamily: "'Alegreya Sans', sans-serif" }}
              >
                Setting the PACE in education
              </h3>
              <div className="mt-2 w-10 h-0.5 bg-[#ff6b00]" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Welcome;
